import React from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import MainContainer from "../../components/MainContainer";
import Title from "../../components/Title";
import { useOnboardingWizard } from "./hooks/useOnboardingWizard";
import { useStyles } from "./styles";
import Step1SelectProfile from "./Step1SelectProfile";
import Step2BusinessData from "./Step2BusinessData";
import Step3BusinessHours from "./Step3BusinessHours";
import Step4Professionals from "./Step4Professionals";
import Step5ServicesCatalog from "./Step5ServicesCatalog";
import Step6KanbanPreview from "./Step6KanbanPreview";
import Step7Confirm from "./Step7Confirm";
import BackdropLoading from "../../components/BackdropLoading";

const STEPS = ["Perfil", "Datos", "Horarios", "Profesionales", "Servicios", "Kanban", "Confirmar"];

const STEP_COMPONENTS = [
  Step1SelectProfile,
  Step2BusinessData,
  Step3BusinessHours,
  Step4Professionals,
  Step5ServicesCatalog,
  Step6KanbanPreview,
  Step7Confirm
];

export default function BusinessOnboarding() {
  const classes = useStyles();
  const wizard = useOnboardingWizard();
  const { step, nextStep, prevStep, loading } = wizard;

  if (loading) return <BackdropLoading open />;

  const StepComponent = STEP_COMPONENTS[step];

  return (
    <MainContainer>
      <Title>Configuración inicial del negocio</Title>
      <Stepper activeStep={step} className={classes.stepper}>
        {STEPS.map((label) => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
      </Stepper>
      <div className={classes.stepContent} key={step}>
        {StepComponent && (step === 5 ? <StepComponent profileId={wizard.profileId} /> : <StepComponent {...wizard} />)}
      </div>
      <div className={classes.navButtons}>
        <Button disabled={step === 0} onClick={prevStep}>Atrás</Button>
        {step < 6 && <Button variant="contained" color="primary" onClick={nextStep}>Siguiente</Button>}
      </div>
    </MainContainer>
  );
}
